export const FILE_TYPE_XLSX =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
